import React, { createContext, useReducer } from 'react'
import { IUser, IUserAction, USER_ACTIONS } from './userReducer/model.d'
import { userReducer } from './userReducer'

export interface IGlobalState {
    user: IUser
}

export interface IDispatch {
    type: USER_ACTIONS, // Will add another by | X_ACTIONS | Y_ACTIONS
    payload: any
}


const initialGlobalState: IGlobalState = {
    user: {}
}

const AppContext = createContext<{
    state: IGlobalState;
    dispatch: React.Dispatch<IDispatch>
}>({
    state: initialGlobalState,
    dispatch: () => null
})

// actions: Will add another by | IXAction | IYAction
const mainReducer = ({ user }: IGlobalState, action: IUserAction) => ({
    user: userReducer(user, action as IUserAction),
    // Add another reducer here
})

const AppProvider = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
    const [state, dispatch] = useReducer(mainReducer, initialGlobalState)

    return (
        <AppContext.Provider value= {{ state, dispatch }}>
            { children }
        </AppContext.Provider>
    )
}

export { AppContext, AppProvider }